export default __webpack_public_path__ + "static/media/iconfinder-256.e68cda01.png";